<template>
    <a href="#" :class="link ? '' : 'btn btn-outline-secondary'" type="button" id="button-addon2"
        data-toggle="tooltip" data-placement="top" title="Atualizar dados da tabela de preço."
        @click.prevent="atualizarItemTabela ()">

        <div class="spinner-border spinner-border-sm" role="status" v-if="atualizando">
            <span class="sr-only">Loading...</span>
        </div>
            
        <i class="fas fa-sync-alt" v-else></i>

    </a>
</template>

<script>
import $ from 'jquery';

export default {
    data () { 
        return { 
            atualizando: false, 
        }
    },

    props: ['proc', 'consumo', 'link', 'lista', 'index', 'id_guia', 'todos'],

    methods: { 
        atualizarItemTabela () { 

            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( this.todos ) { 

                if ( !confirm('Confirma o recálculo de todos os itens?') ) { 
                    return;
                }

                this.$util.atualizar (this, { 
                    service: 'atendimentos',
                    func: 'precificar_todos',
                    dados: { 
                        lista: this.lista, 
                    },
                    callback: res => { 
                        this.atualizando = false;
                        this.$emit('refresh', res);
                        $('[data-toggle="tooltip"]').tooltip('dispose');
                    },
                    toast: true, 
                    final: () => { 
                        this.atualizando = false;
                    }
                });

                return;

            }

            //

            if ( this.proc && !this.proc.id_atendimento_procedimento ) { 
                this.$emit('refresh');
                return;
            } else if ( this.consumo && !this.consumo.id_consumo_procedimento_guia ) { 
                this.$emit('refresh');
                return;
            }

            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.atualizando = true;

            if( !this.proc && this.consumo ) { 

                this.$util.atualizar (this, { 
                    service: 'consumo',
                    func: 'recalcular',
                    dados: { 
                        id_consumo_procedimento_guia: this.consumo.id_consumo_procedimento_guia,
                        id_guia: this.id_guia, 
                    },
                    callback: res => { 
                        this.atualizando = false;
                        this.$emit('refresh', res);
                        $('[data-toggle="tooltip"]').tooltip('dispose');
                    },
                    toast: true, 
                    final: () => { 
                        this.atualizando = false;
                    }
                });

                return;
            } 

            if ( this.proc && this.proc.js_solics && this.proc.js_solics.fl_block_valor ) { 
                if ( !confirm('Item definido sem valor. Forçar o recálculo?') ) { 
                    this.atualizando = false;
                    return;
                }
            }

            this.$util.atualizar (this, { 
                service: 'atendimentos',
                func: 'precificar',
                dados: { 
                    ...this.proc,
                    index: this.index, 
                    lista: this.lista, 
                    id_guia: this.id_guia, 
                    force: true 
                },
                callback: res => { 
                    this.atualizando = false;
                    this.$emit('refresh', res);
                    $('[data-toggle="tooltip"]').tooltip('dispose');
                },
                toast: true, 
                final: () => { 
                    this.atualizando = false;
                }
            });

        }
    }
}
</script>